import {
  schAloftDate,
  schAloftPrice,
  schHoaFeeFrequency,
  schLatitudeLongitude,
  schLocationType,
  schMainPropertyType,
  schPropertyInterest,
} from '@aloft/toolkit-shared';

import { z } from 'zod';

export const schSubjectPropertyDetailsForm = z
  .object({
    zoning: z.string(),
    zoningCompliance: z.string(),
    parcelNumber: z.string().optional(),
    newConstruction: z.boolean().default(false),
    locationType: schLocationType,
    hoa: z.string(),
    hoaFeeAmount: z.preprocess((val) => (val === '' ? undefined : val), schAloftPrice.optional()),
    hoaFeeFrequency: schHoaFeeFrequency,
    legalDescription: z.string(),
    pud: z.boolean().default(false),
    propertyInterest: schPropertyInterest,
    propertyInterestOther: z.string(),
    coordinates: schLatitudeLongitude.optional(),
    propertyType: schMainPropertyType,
  })
  .partial()
  .superRefine((data, ctx) => {
    if ((!data.parcelNumber || data.parcelNumber.trim().length === 0) && !data.newConstruction) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Required',
        path: ['parcelNumber'],
      });
    }

    if (data.propertyInterest === 'Other') {
      if (!data.propertyInterestOther || data.propertyInterestOther.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required',
          path: ['propertyInterestOther'],
        });
      }
    }

    if (
      data.hoaFeeAmount &&
      data.hoaFeeAmount.toDollarLike() > 0 &&
      (!data.hoaFeeFrequency || String(data.hoaFeeFrequency).trim().length === 0)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Required',
        path: ['hoaFeeFrequency'],
      });
    }
  });

export type SubjectPropertyDetailsFormOutput = z.infer<typeof schSubjectPropertyDetailsForm>;

export const schOrderDetailsForm = z
  .object({
    effectiveDate: schAloftDate,
    inspectionDate: schAloftDate,
    intendedUsers: z.string(),
    intendedUse: z.string(),
    totalRenovationBudget: schAloftPrice,
  })
  .partial()
  .superRefine((data, ctx) => {
    if (!data.effectiveDate || data.effectiveDate.getYear() < 2020) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Effective Date must be present and greater or equal to 2020',
        path: ['effectiveDate'],
      });
    }
  });

export type SubjectPropertyDetailsForm = z.infer<typeof schSubjectPropertyDetailsForm>;

export type OrderDetailsFormOutput = z.infer<typeof schOrderDetailsForm>;
